import { type IconProps } from "@octopus-energy/icons"
import { type Maybe } from "@oefr/utils/types"
import { omit } from "remeda"
import { MarketNameIcon } from "@/components/atoms/MarketNameIcon"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    supplyPoint: graphql(`
        fragment SupplyPointIcon_SupplyPoint on SupplyPointType {
            marketName
        }
    `),
}

type SupplyPointIconProps = {
    supplyPoint: Maybe<FragmentOf<typeof graphQLFragments.supplyPoint>>
} & IconProps

export function SupplyPointIcon(props: SupplyPointIconProps) {
    const supplyPoint = readFragment(graphQLFragments.supplyPoint, props.supplyPoint)

    return (
        <MarketNameIcon
            marketName={supplyPoint?.marketName}
            {...omit(props, ["supplyPoint"])}
        />
    )
}

SupplyPointIcon.fragments = graphQLFragments
